// extracted by mini-css-extract-plugin
export default {"-large":"kFmtJ6LhBqIjTxM5DcFj","smallTool":"z2ys_txRbeg93ELQBTmQ","bigTool":"DiZJ7G5jRXU7GpLIoy3u"};